import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LANG_LABELS = { pt: 'PT-BR', en: 'EN-US', es: 'ES-419' };

export const LanguageIndicatorChip = ({ language }) => {
  const { t } = useTranslation('audit');
  if (!language || !LANG_LABELS[language]) return null;
  const langName = t(`_meta.languages.${language}`);
  return (
    <Tooltip title={t('_meta.languageIndicator', { lang: langName })} arrow>
      <Chip
        label={LANG_LABELS[language]}
        size="small"
        variant="outlined"
        sx={{
          ml: 0.5,
          height: '16px',
          fontSize: '10px',
          borderRadius: '4px',
          verticalAlign: 'middle',
        }}
      />
    </Tooltip>
  );
};
